import React from "react";
import { Sparkle } from "lucide-react";
import { BRANDS } from "../data/data";

export function Marquee() {
  return (
    <div
      id="marquee"
      className="marquee-wrap py-6 overflow-hidden"
      style={{ background: "#0B0E13", borderTop: "1px solid rgba(255,255,255,0.08)", borderBottom: "1px solid rgba(255,255,255,0.08)" }}
    >
      <div className="marquee-track">
        {[...BRANDS, ...BRANDS].map((b, i) => (
          <span
            key={i}
            className="mx-8 flex items-center gap-8 whitespace-nowrap text-lg md:text-2xl"
            style={{ fontFamily: "Fraunces, serif", color: "rgba(245,241,234,0.7)" }}
          >
            {b} <Sparkle size={16} color="#FF8A00" fill="#FF8A00" />
          </span>
        ))}
      </div>
    </div>
  );
}

export default Marquee;
